var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterAquaLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.5V4.5H12V10.5H8V0.5H32V10.5H28ZM32 19.5C32.5667 19.5 33.0417 19.3083 33.425 18.925C33.8083 18.5417 34 18.0667 34 17.5C34 16.9333 33.8083 16.4583 33.425 16.075C33.0417 15.6917 32.5667 15.5 32 15.5C31.4333 15.5 30.9583 15.6917 30.575 16.075C30.1917 16.4583 30 16.9333 30 17.5C30 18.0667 30.1917 18.5417 30.575 18.925C30.9583 19.3083 31.4333 19.5 32 19.5ZM28 32.5V24.5H12V32.5H28ZM32 36.5H8V28.5H0V16.5C0 14.8 0.583333 13.375 1.75 12.225C2.91667 11.075 4.33333 10.5 6 10.5H34C35.7 10.5 37.125 11.075 38.275 12.225C39.425 13.375 40 14.8 40 16.5V28.5H32V36.5ZM36 24.5V16.5C36 15.9333 35.8083 15.4583 35.425 15.075C35.0417 14.6917 34.5667 14.5 34 14.5H6C5.43333 14.5 4.95833 14.6917 4.575 15.075C4.19167 15.4583 4 15.9333 4 16.5V24.5H8V20.5H32V24.5H36Z",
    fill: "#038D92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterAquaLg);
export default __webpack_public_path__ + "static/media/printerAquaLg.a3bc8bed79fdbd14f366576475a03bab.svg";
export { ForwardRef as ReactComponent };